import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Page, Boundary, NavbarItem } from '~/components'
import { useCurrentRouteId } from '~/hooks'

const withIsActive =
  (routeId?: string) =>
  (item: NavbarItem): NavbarItem => ({
    ...item,
    active: routeId?.includes(item.to),
  })

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/settings')({
  component: RouteComponent,
})

function RouteComponent() {
  const routeId = useCurrentRouteId()
  const items = (
    [
      {
        children: 'General',
        to: '/workspaces/$workspaceId/bots/$botId/settings/general',
      },
      {
        children: 'Access Control',
        to: '/workspaces/$workspaceId/bots/$botId/settings/access-control',
      },
    ] as const satisfies NavbarItem[]
  ).map(withIsActive(routeId))

  return (
    <Page className="max-w-5xl" title="Bot Settings" navbarItems={items}>
      <Boundary>
        <Outlet />
      </Boundary>
    </Page>
  )
}
